// extracted by css-extract-rspack-plugin
export default {"container":"rIyS3"};